module.exports = __webpack_public_path__ + "img/icon_map_53_off_010.fb98ac52.png";